module.exports = __webpack_public_path__ + "static/img/care.e857078.png";


//////////////////
// WEBPACK FOOTER
// ./static/care.png
// module id = A57E
// module chunks = 1